// extracted by mini-css-extract-plugin
module.exports = {"gridCard4":"styles_gridCard4__VB6vx","gridCard2":"styles_gridCard2__2inDr"};